// @ts-nocheck
import useFilteredVariantTraits from "@insite/client-framework/Common/Hooks/useFilteredVariantTraits";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import updateVariantSelection from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Select, { SelectProps } from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";
// Valtech Custom Code
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { productNumbers } from "@store/Themes/common/props/product";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getProductRealTimePrice } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { IconWrapper } from "@insite/mobius/Icon";
import Tooltip from "@insite/mobius/Tooltip";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import useSetSelectedVariant from "@store/Framework/Common/Hooks/useSetSelectedVariant";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import cloneDeep from "lodash/cloneDeep";

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasParentProductId;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({
    variantTraits: getProductState(state, ownProps.parentProductId).value?.variantTraits,
    variantChildren: getVariantChildrenDataView(state, ownProps.parentProductId).value,
    variantSelection: state.pages.productDetails.variantSelection,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    variantProductState: getProductState(state, state.pages.productDetails.selectedProductId),
    selectedProductId: state.pages.productDetails.selectedProductId,
});

const mapDispatchToProps = {
    updateVariantSelection,
};

export interface ProductDetailsVariantOptionsStyles {
    wrapper?: InjectableCss;
    select?: SelectProps;
    // Valtech Custom Code
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const variantOptionsStyles: ProductDetailsVariantOptionsStyles = {
    wrapper: {
        css: css`
            width: 80%;
            max-width: ${pxToRem(335)};
        `,
    },
    select: {
        cssOverrides: {
            formField: css`
                ${contentSpacingStyles(0, 0, pxToRem(15))}
            `,
            formInputWrapper: css`
                margin-top: ${pxToRem(10)} !important;

                ${IconWrapper} {
                    color: ${getColor("primary")};
                }
            `,
            inputSelect: css`
                padding-right: 2em;
                text-overflow: ellipsis;

                &:focus,
                &:active {
                    padding-right: 2em;
                    border: ${pxToRem(2)} solid ${getColor("primary")};
                }
            `,
        },
    },
    labelText: {
        ...productNumbers.labelText,
        transform: "none",
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.base};
        `,
    },
    valueText: {
        ...productNumbers.valueText,
        transform: "none",
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.base};
        `,
    },
};

const styles = variantOptionsStyles;

const ImageContainer = styled.div`
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    margin: 1rem;
`;

const ImageThumbnail = styled.img`
    cursor: pointer;
    height: 5rem;
    width: 6.5rem;
    outline: 1px lightgrey solid;
    border-radius: 0.5rem;
    object-fit: cover;
    transition: transform 0.2s;
    &:hover {
        transform: scale(1.2);
    }
`;

const ProductDetailsVariantOptionImages: React.FC<Props> = ({
    variantChildren,
    variantSelection,
    updateVariantSelection,
    variantTraits,
    parentProductId,
    variantProductState,
    selectedProductId,
}) => {
    // const [filteredVariantTraits, setFilteredVariantTraits] = React.useState<VariantTraitModel[]>(); // Valtech Custom Code
    const setSelectedVariant = useSetSelectedVariant();

    useEffect(() => {
        if (
            variantProductState.value &&
            (variantProductState.value.isVariantParent || variantProductState.value.childTraitValues)
        ) {
            window.history.replaceState(null, "", variantProductState.value.canonicalUrl);
        }
    }, [selectedProductId]);
    // // Bunzl Custom Code -->
    // const filteredVariantTraits =
    //     variantTraits && variantChildren
    //         ? useFilteredVariantTraits(variantTraits, variantChildren, variantSelection)
    //         : undefined;
    // filteredVariantTraits?.forEach(variantTrait => {
    //     if (variantTrait.traitValues && variantTrait.traitValues?.length <= 1) {
    //         if (variantTrait.traitValues[0].id === variantSelection[variantTrait.id]) {
    //             return;
    //         }
    //         updateVariantSelection({
    //             traitValueId: variantTrait.traitValues[0].id,
    //             variantTraitId: variantTrait.id,
    //             productId: parentProductId,
    //         });
    //     }
    // });
    // // Bunzl Custom Code <--
    // Valtech Custom Code -->

    // <-- Valtech Custom Code

    const variantChangeHandler = (traitValueId: string, variantTraitId: string) => {
        updateVariantSelection({ traitValueId, variantTraitId, productId: parentProductId });
    };

    const productDetails = useAppSelector(state => state.pages.productDetails);

    if (!variantTraits || variantTraits.length === 0 || !variantChildren) {
        return null;
    }

    const handleImageClick = async (variant: ProductModel) => {
        let selectedVariantPricing;
        if (variant.canShowPrice === true) {
            selectedVariantPricing = await getProductRealTimePrice({
                productId: variant.id,
                qtyOrdered: 1,
                unitOfMeasure: "",
            });
        }
        const variantProductInfo = cloneDeep(productDetails?.productInfosById?.[variant?.id]);
        if (variantProductInfo) {
            variantProductInfo.pricing = selectedVariantPricing;
            setSelectedVariant({ variantId: variant.id, productInfo: variantProductInfo });
        }
    };

    // Valtech Moved Code --> filteredVariantTraits moved up in useEffect

    const getAttributesToShow = (variant: ProductModel) => {
        const attributesToShow = variant.attributeTypes?.filter(attributeType => attributeType.isFilter);
        return attributesToShow
            ?.map(attributeType => `${attributeType.label}: ${attributeType.attributeValues?.[0].valueDisplay}`)
            .join("\n");
    };

    return (
        <ImageContainer>
            {variantChildren?.map(variant => {
                return (
                    <ImageThumbnail
                        onClick={() => handleImageClick(variant)}
                        alt={variant.productNumber}
                        src={variant.smallImagePath}
                        key={variant.id}
                        style={variant.id === selectedProductId ? { outline: "1px grey solid" } : undefined}
                        title={getAttributesToShow(variant)}
                    />
                );
            })}
        </ImageContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsVariantOptionImages)),
    definition: {
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
